/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_163_DescriptionInputs */

const en_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cradle the blue planet with focus in the Planet Guardian’s palm.`)
};

const ar_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احتضن الكوكب الأزرق بتركيز في كف حارس الكوكب.`)
};

const de_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiegen Sie den blauen Planeten mit Fokus in der Handfläche des Planetenwächters.`)
};

const es_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acuna el planeta azul con atención en la palma de la mano del Guardián del Planeta.`)
};

const fr_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bercez la planète bleue au creux des paumes du Gardien. Votre concentration, entre ses branches, est en sécurité.`)
};

const it_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custodisci il pianeta blu con la concentrazione nel palmo della mano del Guardiano del Pianeta.`)
};

const ja_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラネット・ガーディアンの手のひらで、青い地球をやさしく包み込み、集中しましょう。`)
};

const ko_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`행성 수호자의 손바닥 위에서 집중하며 푸른 행성을 부드럽게 감싸 안으세요.`)
};

const pt_br_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embale o planeta azul com seu foco na palma da Guardiã do Planeta.`)
};

const ru_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Держите голубую планету в режиме фокусировки на ладони Хранителя планет.`)
};

const th_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โอบอุ้มโลกไว้ด้วยพลังแห่งการโฟกัสในอุ้งมือของผู้พิทักษ์โลก`)
};

const tr_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mavi gezegeni, Gezegen Koruyucusu'nun avucunda, tüm dikkatinle kucakla.`)
};

const zh_cn_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在守星木的掌心里，用专注守护蔚蓝星球。`)
};

const zh_tw_tree_type_163_description = /** @type {(inputs: Tree_Type_163_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在守星木的掌心裡，用專注守護蔚藍星球。`)
};

/**
* | output |
* | --- |
* | "Cradle the blue planet with focus in the Planet Guardian’s palm." |
*
* @param {Tree_Type_163_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_163_description = /** @type {((inputs?: Tree_Type_163_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_163_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_163_description(inputs)
	if (locale === "ar") return ar_tree_type_163_description(inputs)
	if (locale === "de") return de_tree_type_163_description(inputs)
	if (locale === "es") return es_tree_type_163_description(inputs)
	if (locale === "fr") return fr_tree_type_163_description(inputs)
	if (locale === "it") return it_tree_type_163_description(inputs)
	if (locale === "ja") return ja_tree_type_163_description(inputs)
	if (locale === "ko") return ko_tree_type_163_description(inputs)
	if (locale === "pt_br") return pt_br_tree_type_163_description(inputs)
	if (locale === "ru") return ru_tree_type_163_description(inputs)
	if (locale === "th") return th_tree_type_163_description(inputs)
	if (locale === "tr") return tr_tree_type_163_description(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_163_description(inputs)
	return zh_tw_tree_type_163_description(inputs)
});